import React, { useEffect, lazy, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ParentStyled from './style';
import { loadStyle, hasEnabledFeature, loadPageConfig, getNewObject, hasRestrictedRole } from 'globalutils/fmUtils';
import { pageUrls, COOKIE_AUTH_DETAILS, ROLES } from 'globalconfig/constants/keys';
import { getCookie } from 'globalservices/cookie';
import { sortColumnMapping, allTabs, basicRequest } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

let Styled = loadStyle(ParentStyled, 'pages/web/PendingMechanicInspections');
const layout = window?.$environment?.CURRENT_LAYOUT;
const config = loadPageConfig();
const Content = lazy(() => import(`@/${config.pendingMechanicInspections[1].name}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));
const isServiceManager = hasRestrictedRole([ROLES.SERVICE_MANAGER]);

const Inspections = (parentProps) => {
  const { fetchInspections, getFilters, fetchDashboardData, fetchDriverUserListing, getDocumentToken, history, i18n, theme } =
    parentProps;
  const commonParentProps = { history, i18n, Styled, theme };

  const [pagination, setPagination] = useState(false);
  const [request, setRequest] = useState({ ...basicRequest });

  const changeRequest = (fields) => {
    if (fields?.sortCol) {
      const type = fields.sortCol;
      fields.sortCol = sortColumnMapping[type] ? sortColumnMapping[type] : fields.sortCol;
    }
    setRequest({ ...basicRequest, ...fields });
  };

  useEffect(() => {
    const user = getCookie(COOKIE_AUTH_DETAILS);
    let requestToModify = { ...request };
    if (hasRestrictedRole([ROLES.MECHANIC])) {
      requestToModify = { ...request, mechanicId: user?.userId };
    } else if (hasRestrictedRole(['DRIVER'])) {
      requestToModify = { ...request, driverId: user?.userId };
    }
    fetchInspections({
      apiId: 'fetchPendingMechanicInspections',
      data: { request: requestToModify, state: 'NOT_STARTED' },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);

  useEffect(() => {
    fetchDriverUserListing({
      listApiId: 'fetchDriverUser',
    });
    if (checkServiceProvider('fetchDashboardData', window.$environment.SERVICE_PROVIDER, false)) {
      fetchDashboardData({ fetchApi: 'dashboardApi' });
    }
    getFilters({ apiId: 'getFilters' });
    getDocumentToken({ apiId: 'getDocToken' });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isCustomDviRequired = hasEnabledFeature('customDvirEnabled') && !isServiceManager;
  const isAdvancedDviRequired = hasEnabledFeature('advancedDvirEnabled') && !isServiceManager;
  return (
    <RenderComponentTab
      {...config.pendingMechanicInspections[1]}
      parentProps={{
        ...parentProps,
        isAdvancedDviRequired,
        isCustomDviRequired,
        changeRequest,
        request,
        pagination,
        setPagination,
      }}
      commonParentProps={commonParentProps}
      component={Content}
      history={history}
      i18n={i18n}
      pagination={pagination}
      setPagination={setPagination}
    />
  );
};

const RenderComponentTab = ({
  name,
  props,
  commonProps,
  title,
  parentProps,
  commonParentProps,
  component,
  history,
  i18n,
  verticalTab,
  selectedIndex,
  setSelectedIndexfn,
  pagination,
  setPagination,
  ...rest
}) => {
  const Component = component;

  const handleChange = (event, newValue) => {
    history.push(tabValues[newValue].url);
  };

  let newProps = props?.length ? getNewObject(parentProps, props) : {};
  newProps = {
    ...newProps,
    ...(commonProps?.length ? getNewObject(commonParentProps, commonProps) : {}),
    ...rest,
  };

  useEffect(() => {
    if (document.getElementById('list1')) {
      const isSelected = document.getElementById('list1')?.className.includes('Mui-selected');
      document.getElementById('list1').className = !isSelected
        ? document.getElementById('list1').className + ' Mui-selected'
        : document.getElementById('list1').className;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document.getElementById('list1')]);

  const tabValues = useMemo(() => {
    const sharedValue = (
      <Component {...newProps} selectedIndex={selectedIndex} pagination={pagination} setPagination={setPagination} />
    );
    let visibleTabs = [...allTabs];

    if (isServiceManager || hasRestrictedRole([ROLES.MECHANIC])) {
      visibleTabs.pop();
    } else {
      visibleTabs.shift();
    }

    if (hasRestrictedRole([ROLES.MECHANIC])) {
      visibleTabs.shift();
    }

    return visibleTabs.map((tab) => ({
      name: tab.name,
      value: sharedValue,
      url: pageUrls[tab.key],
    }));
  }, [newProps, selectedIndex, pagination, setPagination]);

  return (
    <Styled.Content>
      <Tab
        data={tabValues}
        className="logwrapper"
        currentTab={isServiceManager ? 1 : 0}
        onChange={handleChange}
        vertical={true}
      />
    </Styled.Content>
  );
};
const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    inspections: state.pendingMechanicInspections,
    list: state.inspections,
    filters: state.filters,
    logBook: state.logBook,
  };
};
const mapDispatch = (dispatch) => {
  return {
    fetchInspections: (data) => dispatch.pendingMechanicInspections.fetchData(data),
    fetchDashboardData: (data) => dispatch.dashboard.fetchData(data),
    bulkDownloadReport: (data) => dispatch.logBook.downloadData(data),
    fetchDriverUserListing: (data) => dispatch.inspections.fetchData(data),
    getFilters: (data) => dispatch.filters.fetchData(data),
    getDocumentToken: (data) => dispatch.logBook.documentToken(data),
    clearApiStatus: () => dispatch.asyncRequests.clearApiStatus(),
    viewReport: (data) => dispatch.viewReport.viewReportDocument(data),
  };
};

export default connect(mapState, mapDispatch)(Inspections);
Inspections.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  fetchDashboardData: PropTypes.func.isRequired,
  fetchInspections: PropTypes.func.isRequired,
};
